import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ComponentRef, OnDestroy, ViewChild, ViewContainerRef, computed } from '@angular/core';
import { XMLElementBaseComponent } from '../base';
import { Point } from '../volkswagen.types';

@Component({
  selector: 'app-vw-list-point',
  imports: [CommonModule],
  standalone: true,
  template: `
    <li class="mb-2 ml-5 max-w-4xl list-disc text-sm italic leading-relaxed text-gray-800">
      @if (data.text) {
        {{ data.text }}
      }

      @if (title()) {
        {{ title() }}
      }

      @if (data.children && data.children.length > 0) {
        <div class="ml-2 mt-1">
          <ng-template #childrenContainer class="space-y-1"></ng-template>
        </div>
      }

      <!-- <div class="bg-violet-100 text-xs">{{ data | json }}</div> -->
    </li>
  `,
})
export class PointComponent extends XMLElementBaseComponent<Point> implements AfterViewInit, OnDestroy {
  @ViewChild('childrenContainer', { read: ViewContainerRef })
  childrenContainer!: ViewContainerRef;

  private childComponents: ComponentRef<XMLElementBaseComponent>[] = [];

  getText(child: any): string | undefined {
    if (child.tag === 'titel' || child.tag === 'taste') {
      return child.text;
    }
    if (child['children']) {
      return child['children'].map((gc: any) => this.getText(gc)).join(' ');
    }
    return undefined;
  }

  title = computed(() => {
    const children = this.data?.children?.filter((child: any) => child.tag === 'qv-kap' || child.tag === 'taste') || [];
    if (children.length > 0) {
      const list = children.map((child: any) => this.getText(child)).join(' ');
      return list;
    }
    return undefined;
  });

  ngAfterViewInit() {
    if (this.data?.children) {
      // without wz
      const furtherChildren = this.data?.children?.filter((child: any) => !['wz'].includes(child.tag)) || [];
      this.childRenderService.setProvider(this.provider);
      this.childComponents = this.childRenderService.renderChildren(furtherChildren, this.childrenContainer);
    }
  }

  ngOnDestroy() {
    this.childComponents.forEach((ref) => ref.destroy());
  }
}
